import { makeStyles } from "@mui/styles";
import theme from "mui/theme";

export const carouselStyles = makeStyles(() => ({
  carousel__root: {
    overflow: "hidden",
  },

  carousel__image: {
    position: "absolute",
    bottom: "11vh",
    left: 0,

    transition: "opacity ease 2s",
    opacity: 0,

    "& img": {
      width: "100vw",
      height: "auto",
    },

    [theme.breakpoints.only("tablet")]: {
      "& img": {
        maxHeight: "70vh",
      },
    },
  },
}));
